import  "./paragraph.css";

export default function Parrafo({clase,title}) {
    return (
      <p className={clase}>{title}</p>
    );
  }